"use client"

import Title from "@/components/common/Typography/Title"
import { Col, Row } from "antd"
import Image from "next/image"
import FormSearchFlightMobile from "./FormSearchFlightMobile"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { flightActions } from "@/lib/redux/features/flight/reduce"

import { useTranslation } from "react-i18next"
import { FlightSearchPrefill } from "../../flights/landing/flightSearchPrefill"
import { useEffect, useRef } from "react"
import dayjs from "dayjs"
import DrawerFormSearchFlightWrapper from "./DrawerFormSearchFlightWrapper"
import PageHeaderMobile from "@/components/common/PageHeaderMobile"
import { useTERouter } from "@/hooks/app/useTERouter"
import { usePathname } from "next/navigation"
import { getProductLandingTitleKey } from "@/utils/app/getProductLandingTitleKey"

const DrawerFormSearchFlight = ({ autoHeight, prefill }: { autoHeight?: boolean; prefill?: FlightSearchPrefill }) => {
  const dispatch = useAppDispatch()
  const airports = useAppSelector((state) => state.flight.get_airports.data)
  const didPrefillRef = useRef(false)
  const router = useTERouter()
  const pathname = usePathname()
  const hidePageHeader = !!getProductLandingTitleKey(pathname)
  
  const { t } = useTranslation()

  useEffect(() => {
    if (!prefill) return
    if (didPrefillRef.current) return

    const hasAirports = airports && Object.keys(airports).length > 0
    if (!hasAirports) return

    const normalizeCode = (value?: string) => String(value || "").trim().toUpperCase()
    const startCode = normalizeCode(prefill.startPoint)
    const endCode = normalizeCode(prefill.endPoint)

    const findAirport = (code: string) => {
      if (!code) return null
      return (airports as any)?.[code] || (Object.values(airports as any).find((a: any) => a?.code === code) as any)
    }

    dispatch(flightActions.updateModeSearchFlight({ isMultiCities: false }))
    dispatch(flightActions.changeCheckedItinerary(false))

    // DES_ROUTE: only prefill destination, avoid showing default origin (SGN)
    if (!startCode && !!endCode) {
      dispatch(
        flightActions.selectFromAirport({
          indexInputFlight: 0,
          fromAirport: undefined as any,
        })
      )
    }

    if (startCode) {
      const fromAirport = findAirport(startCode)
      if (fromAirport) dispatch(flightActions.selectFromAirport({ indexInputFlight: 0, fromAirport }))
    }

    if (endCode) {
      const toAirport = findAirport(endCode)
      if (toAirport) dispatch(flightActions.selectToAirport({ indexInputFlight: 0, toAirport }))
    }

    if (prefill.dateFrom) {
      const d = dayjs(prefill.dateFrom)
      dispatch(
        flightActions.changeDateFrom({
          indexInputFlight: 0,
          dateFrom: (d.isValid() ? d : dayjs()).format("YYYY-MM-DD"),
        })
      )
    }

    didPrefillRef.current = true
  }, [airports, dispatch, prefill])

  return (
    <DrawerFormSearchFlightWrapper>
      {!hidePageHeader && (
        <PageHeaderMobile
          title={(
            <Row justify='center'>
              <Col>
                <Title level={5} style={{ margin: 0 }}>
                  {t("common.flight")}
                </Title>
              </Col>
            </Row>
          )}
          shownRight={false}
          onLeftClick={() => router.push('/')}
        />
      )}
      <Col span={24} style={{ height: autoHeight ? 'auto' : 'calc(100vh - 7rem)', minHeight: 500, marginBottom: '2rem' }}>
        <Row
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%'
          }}
        >
          <Image
            src="/static/form-search-banner-2x.png"
            alt="Banner form mobile search flights"
            width={375}
            height={200}
            style={{ width: '100%', height: 'auto' }}
          />
        </Row>
        <Row
          justify='center'
          className="home__searching-mobile--form"
        >
          <Col span={24} className="home__searching-mobile--form-box">

            <Row justify='center'>
              <Col span={24}>
                <Title level={2} style={{ paddingInline: '1.5rem' }}>
                  {/* {t("home.title", { platform: process.env.NEXT_PUBLIC_PLATFORM_NAME })} */}
                </Title>
              </Col>
              <Col span={24} style={{ width: '100%', maxWidth: '100%', paddingInline: 0 }}>
                <FormSearchFlightMobile />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </DrawerFormSearchFlightWrapper>
  )
}

export default DrawerFormSearchFlight